const TipoImportazione = {
    NonSelezionato: 0,
    Corrente: 1,
    Precedente: 2,
};

const toString = (tipo) => {
    switch (tipo) {
        case TipoImportazione.Corrente:
            return '730/2020';
        case TipoImportazione.Precedente:
            return 'anno precedente';
        default:
            return '';
    }
};

TipoImportazione.stringify = toString;

export default TipoImportazione;
